import { render, staticRenderFns } from "./JVxeTextareaCell.vue?vue&type=template&id=3908e89e&scoped=true&"
import script from "./JVxeTextareaCell.vue?vue&type=script&lang=js&"
export * from "./JVxeTextareaCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3908e89e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3908e89e')) {
      api.createRecord('3908e89e', component.options)
    } else {
      api.reload('3908e89e', component.options)
    }
    module.hot.accept("./JVxeTextareaCell.vue?vue&type=template&id=3908e89e&scoped=true&", function () {
      api.rerender('3908e89e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/JVxeTable/components/cells/JVxeTextareaCell.vue"
export default component.exports